import React from "react";

export default function ContextualInsights({ insights }) {
  const styles = {
    warning: { icon: "/icons/overview1.svg" },
    info: { icon: "/icons/overview2.svg" },
    success: { icon: "/icons/overview3.svg" },
    danger: { icon: "/icons/overview4.svg" },
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 flex flex-col w-full min-w-0 min-h-[380px]">
      <h3 className="font-bold text-[12px] text-gray-900">Contextual Insights</h3>
      <p className="text-[10px] text-gray-500 mt-1">
        Actions or observations suggested by the system
      </p>
      <div className="mt-3 space-y-2 w-full min-w-0">
        {insights.map((item, idx) => {
          const s = styles[item.type] || styles.info;
          return (
            <div
              key={idx}
              className="flex items-center gap-2 p-2 rounded-md border border-gray-100 bg-gray-50 w-full min-w-0"
            >
              <span className="flex h-6 w-6 items-center justify-center rounded-md">
                <img src={s.icon} alt={item.type} className="h-4 w-4" />
              </span>
              <span className="text-[11px] text-gray-700 leading-snug min-w-0">
                {item.text}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
